import { render, staticRenderFns } from "./settlementTask.vue?vue&type=template&id=b28ebc6e&scoped=true&"
import script from "./settlementTask.vue?vue&type=script&lang=js&"
export * from "./settlementTask.vue?vue&type=script&lang=js&"
import style0 from "./settlementTask.vue?vue&type=style&index=0&id=b28ebc6e&prod&lang=scss&scoped=true&"
import style1 from "./settlementTask.vue?vue&type=style&index=1&id=b28ebc6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ebc6e",
  null
  
)

export default component.exports